<div class="confirmation-dialog-body">
  <div class="text-center mb-3">
    <img [src]="data.icon" class="img-fluid" alt="" />
  </div>
  <h2 class="text-center">{{ data.title }}</h2>
  <p class="text-center">{{ data.message }}</p>
  <div class="d-sm-flex justify-content-center gap-3">
    <button class="btn cancleBtn mb-sm-0 mb-3" (click)="onCancel()">
      {{ data.cancelButtonText || "Cancel" }}
    </button>
    <button class="btn confirmBtn" (click)="onConfirm()">
      {{ data.confirmButtonText || "Confirm" }}
    </button>
  </div>
</div>
